import { createSlice } from "@reduxjs/toolkit";
import {BestWebSocket} from "../BestWebSocket";

const initialState = {
  socket: null,
}

const socketSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    initSocket: (state) => {
      if(!state.socket) {
        // Используем withCredentials для передачи cookies
        //state.socket = new BestWebSocket(`ws://localhost:8000/ws`, {
        state.socket = new BestWebSocket(`wss://app.iqtag.io:8000/ws`, {
          withCredentials: true
        });
      }
    },
    closeSocket: (state) => {
      if(state.socket) {
        state.socket.disconnect();
        state.socket = null;
      }
    },
  },
});

export const { initSocket, closeSocket } = socketSlice.actions;
export default socketSlice.reducer